<template>
  <div class="subPage">
    <!-- 面包屑 -->
    <bread-crumb>
      <el-breadcrumb-item to="/home">首页</el-breadcrumb-item>
      <el-breadcrumb-item>联系我们</el-breadcrumb-item>
    </bread-crumb>
    <div class="contBox">
      <div class="map">
        <!-- <baidu-map class="bm-view" :center="{ lng: 117.329023, lat: 33.338396 }" :zoom="zoom">
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
          <bm-marker :position="{ lng: 117.329023, lat: 33.338396 }" :dragging="true" animation="BMAP_ANIMATION_BOUNCE"></bm-marker>
        </baidu-map> -->
      </div>
      <div class="diZhiBox">
        <div class="diZhiInfo">
          <h2>安徽汉之韵工程技术咨询服务有限公司</h2>
          <div class="infoItem">
            <i class="iconfont icon-dizhi"></i>
            <span>公司地址：安徽省蚌埠市固镇县投资大厦10楼1001号</span>
          </div>
          <div class="infoItem">
            <i class="iconfont icon-dianhua"></i>
            <span>联系电话：0552-6012968</span>
          </div>
          <div class="infoItem">
            <i class="iconfont icon-youxiang"></i>
            <span>邮箱：3028330036@qq.com</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
// import BaiduMap from "vue-baidu-map";
// Vue.use(BaiduMap, {
//   ak: "OE4opfRdAoGCGzUX3qAaR9hA33e4MYwm",
// });
export default {
  name: "SubPage",
  data() {
    return {
      center: { lng: 117.329023, lat: 33.338396 },
      zoom: 19,
    };
  },
  methods: {},
};
</script>
<style scoped lang="scss">
.subPage {
  min-height: calc(100vh - 406px);
  .contBox {
    width: 1200px;
    margin: 0 auto;
    min-height: calc(100vh - 460px);
    padding-top: 30px;
    display: flex;
    .title {
      font-size: 18px;
      text-align: center;
      font-weight: bold;
    }
    .pbDate {
      color: #999;
      text-align: center;
      margin-bottom: 20px;
    }
    .map {
      width: 680px;
      height: 360px;
      border: 1px solid $border-input-color;
      .bm-view {
        width: 100%;
        height: 360px;
      }
    }
    .diZhiBox {
      width: 420px;
      height: 360px;
      display: flex;
      justify-content: center;
      padding: 40px;
      background: #F7F9FA;
      margin-left: 20px;
      .diZhiInfo {
        h2{
          font-size: 16px;
        }
        .infoItem {
          display: flex;
          padding: 20px 0;
          span {
            font-size: 16px;
          }
          i {
            color: $theme-color;
            margin-right: 6px;
          }
        }
      }
      .dzImg img{
          width: 275px;
      }
    }
  }
}
</style>
